import React from "react";
import "./OutOfHomeHighlights.css";
import { AiOutlineEye } from "react-icons/ai";
import { FaMapMarkerAlt, FaStar } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const OutOfHomeHighlights = () => {
  const { t } = useTranslation();

  const stats = [
    {
      icon: <AiOutlineEye size={48} />,
      value: t("outOfHomePage.highlights.stats.0.value"),
      label: t("outOfHomePage.highlights.stats.0.label"),
      text: t("outOfHomePage.highlights.stats.0.text"),
    },
    {
      icon: <FaMapMarkerAlt size={42} />,
      value: t("outOfHomePage.highlights.stats.1.value"),
      label: t("outOfHomePage.highlights.stats.1.label"),
      text: t("outOfHomePage.highlights.stats.1.text"),
    },
    {
      icon: <FaStar size={42} />,
      value: t("outOfHomePage.highlights.stats.2.value"),
      label: t("outOfHomePage.highlights.stats.2.label"),
      text: t("outOfHomePage.highlights.stats.2.text"),
    },
  ];

  return (
    <div
      className="px-3 py-5 px-md-5 px-xl-custom py-xl-custom d-flex flex-column align-items-center ooh-highlights-section"
      style={{ gap: "90px" }}
    >
      {/* TITLE */}
      <h2
        className="oohs-title"
        style={{ lineHeight: 1.1 }}
        dangerouslySetInnerHTML={{ __html: t("outOfHomePage.highlights.title") }}
      />

      {/* STATS ROW */}
      <div
        className="d-flex flex-column flex-md-row justify-content-center w-100"
        style={{ gap: "60px", maxWidth: "1200px" }}
      >
        {stats.map((stat, index) => (
          <div
            key={index}
            className="d-flex flex-column align-items-center text-center flex-fill"
            style={{ gap: "16px", maxWidth: "340px", margin: "0 auto" }}
          >
            <div className="fw-bold ooh-stat-value">{stat.value}</div>
            <div className="fw-bold text-black" style={{ fontSize: "20px" }}>
              {stat.label}
            </div>
            <p className="fw-light" style={{ fontSize: "16px", color: "#5B6472" }}>
              {stat.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OutOfHomeHighlights;
